export default __webpack_public_path__ + "static/media/3_portugal-image.19670c4a.jpg";